const sanityConfig = {
  projectId: 'wgvzae70',
  dataset: process.env.NEXT_PUBLIC_SANITY_DATASET || '',
  apiVersion: process.env.NEXT_PUBLIC_SANITY_API_VERSION || 'v2024-11-19',
  useCdn: !process.env.ENVIRONMENT && ['beta', 'prod'].includes(process.env.NEXT_PUBLIC_ENVIRONMENT ?? ''), // Use CDN only in production or beta on the client side
}

export default sanityConfig
